'use client';

import React from 'react';
import type { ButtonT } from '@mentimeter/ragnar-ui/button';
import { useTranslations } from 'next-intl';
import { useReferralPropMapper } from '../../utils/useReferralPropMapper';
import { Button } from '../Wrapper/Button';

export const SignupButton = (buttonProps: ButtonT) => {
  const referralPropMapper = useReferralPropMapper();
  const t = useTranslations('first_impression.legacy.common');
  return (
    <Button
      {...buttonProps}
      variant="brand"
      data-testid="header-signup"
      {...referralPropMapper({ href: '/auth/signup' })}
    >
      {t('page_links.sign_up')}
    </Button>
  );
};
